<template>
  <div>
    <div class="config-user">
      <div class="update-config-user">
        <div class="adicao">
          <h5>{{ $t('configuracao-de-perdas') }}</h5>
        </div>
        <div class="mt-2">
          <p>{{ $t('selecione-o-tipo-da-perda-para-configuracao') }}</p>
          <b-form-select id="select-type-loss" v-model="determinatedSelected"
            :options="optionsDeterminate"></b-form-select>
        </div>

        <div v-if="(showLoss && determinatedSelected == 'I') || (showLoss && optionsSelect.length > 1)">
          <p>{{ $t('selecione-a-perda-para-configuracao') }}</p>
          <b-form-select id="select-loss" v-model="lossSelected" :options="optionsSelect"></b-form-select>
        </div>
        <div v-else-if="determinatedSelected == 'D'">
          <p class="mt-2">{{ $t('configure-uma-perda-determinada-como-saida') }}</p>
        </div>

        <TableVue class="mt-2" v-if="areaLossList.length" :configToUser="true" :modelList="areaLossList"
          @addNewInput="addNewInput" @modelChanged="areaLossList = $event" @deleteModel="deleteConfig($event)"
          @deleteSingleInput="deleteSingleInput" />

        <b-icon v-if="(showLoss && determinatedSelected == 'I') || (showLoss && optionsSelect.length > 1)"
          id="btn-icon-add-d" class="btn-iconAdd" :title="$t('adicionar-nova-linha')" icon="plus-circle-fill"
          @click="addDetermineted()" aria-hidden="true" />

        <b-icon v-if="!showLoss" id="btn-icon-add-i" class="btn-iconAdd" :title="$t('adicionar-nova-linha')"
          icon="plus-circle-fill" @click="addUndetermineted()" aria-hidden="true" />
      </div>
      <div class="side-loss-view">
        <ConfigLossToUserView class="loss-view" :determinatedList="determinatedList"
          :undeterminatedList="undeterminatedList" />
      </div>
    </div>
    <hr />
    <b-row class="groupBtn mt-2">
      <img class="float-right" src="@/assets/salvar.png" style="margin-left: 30px;" :title="$t('salvar-configuracoes')"
        :alt="$t('salvar-configuracoes')" @click="save" />
      <img class="float-right" src="@/assets/sair.png" style="margin-left: 8px;" :title="$t('sair')" :alt="$t('sair')"
        @click="cancel" />
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import { urlMainAPI, defaultSuccess } from "../../../global";
import { Mapping } from "./tools/InitialKpisCollection";
import LossConfiguration from "./models/LossConfiguration";
import LossStructure from "./models/LossStructure";
import ConfigLossToUserView from "./template/configLossToUser.vue";
import TableVue from "./template/table.vue";

export default {
  name: "ConfigInputToUser",
  components: { ConfigLossToUserView, TableVue },
  props: ["determinatedList", "undeterminatedList", "lossList", "lossOthersList"],
  inject: ["updateInputLossUser"],

  data() {
    return {
      optionsSelect: [],
      lossSelected: null,
      optionsDeterminate: [
        { value: "D", text: this.$t('determinada') },
        { value: "I", text: this.$t('indeterminada') },
      ],
      determinatedSelected: "D",
      areaLossList: [],
      lossListLocal: [...this.lossList, ...this.lossOthersList],
      showLoss: true,

    };
  },

  watch: {
    lossSelected(value) {
      this.loadConfigSelected(value)
    },

    determinatedSelected() {
      if (this.determinatedSelected == "D") {
        this.loadDetermineted();
        this.showLoss = true;
      } else {
        this.loadUndetermineted();
        this.showLoss = false;
      }
    }
  },

  methods: {
    addNewInput(map) {
      if (this.determinatedSelected == "D") {
        let det = this.determinatedList.find((d) => d.id == this.lossSelected);
        let loss = det.childrens.find(l => l.id == map.parentId)
        if (loss) {
          loss.mi.push(map);
          loss.mi.sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? -1 : 0)
        }
      }
      else {
        let loss = this.undeterminatedList.find(l => l.id == map.parentId)
        if (loss) {
          loss.mi.push(map)
          loss.mi.sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? -1 : 0)
        }
      }
    },

    async loadConfigSelected(id) {
      let det = await this.determinatedList.find((d) => d.id == id);

      this.areaLossList = new Array();
      if (det) {
        this.setAreaLossList(det.childrens);
      }
    },

    setAreaLossList(list = Array) {
      list.forEach((l) => {
        l.mi.forEach(mi => this.areaLossList.push(mi))
        this.areaLossList.push(l.mo);
      });
    },

    loadDetermineted() {
      this.optionsSelect = new Array();
      this.optionsSelect = this.lossListLocal.map((l) => ({
        value: l.id,
        text: l.variable,
      }));
      if (this.lossListLocal[0])
        this.lossSelected = this.lossListLocal[0].id;

      this.loadConfigSelected(this.lossSelected);
    },

    setOthersLast() {
      let indexOuther = 0;
      let others = this.determinatedList.find((d, i) => {
        if (d.id == -9999) {
          indexOuther = i
          return d
        }
      })

      if (others) {
        this.determinatedList.splice(indexOuther, 1)
        this.determinatedList.push(others)
      }
    },

    loadUndetermineted() {
      this.areaLossList = new Array();
      this.undeterminatedList.forEach((l) => {
        l.mi.forEach(mi => this.areaLossList.push(mi))
        this.areaLossList.push(l.mo);
      });
    },

    async save() {
      defaultSuccess(this.$t('salvando-dados'));

      const normalizeId = (item, isDetermined) => {
        if (typeof item.id === 'string') {
          item.id = 0;
        }

        if (isDetermined && item.childrens) {
          item.childrens.forEach(child => {
            if (child.mi) {
              child.mi.forEach(mapping => {
                if (typeof mapping.id === 'string') {
                  mapping.id = 0;
                }
              });
            }
            if (child.mo && typeof child.mo.id === 'string') {
              child.mo.id = 0;
            }
          });
        } else {
          if (item.mi) {
            item.mi.forEach(mapping => {

              if(mapping.id == 0){
                mapping.parentId = -9999
              }

              if (typeof mapping.id === 'string') {
                mapping.id = 0
                mapping.parentId = -9999
              }
            });
          }
          if (item.mo && typeof item.mo.id === 'string') {
            item.mo.id = 0;
            item.mo.parentId = -9999;
          }
        }
      };

      this.determinatedList.forEach(lossConfig => {
        normalizeId(lossConfig, true); 
      });

      this.undeterminatedList.forEach(lossStructure => {
        normalizeId(lossStructure, false); 
      });

      let formConfig = {
        determinated: this.determinatedList,
        undeterminated: this.undeterminatedList
      };

    

      const url = `${urlMainAPI}/savelossinputsettings`;
      await axios
        .post(url, formConfig)
        .then((res) => {
          defaultSuccess(res.data);
        })
        .catch();

      this.$emit("updateForm", ++this.closeClikEvent);
      this.updateInputLossUser();
      this.cancel();
    }
    ,

    cancel() {
      this.$bvModal.hide("ConfigInputToUser");
    },

    addDetermineted() {
      let lossFounded = this.determinatedList.find((d) => d.id == this.lossSelected);
      let inputId = `${Math.round(((Math.random() * 10000) + (Math.random() * 100000)))}-novoInput`
      let mo = new Mapping({ id: inputId, type: "O", operation: "papurd" });
      let mi = new Mapping({ id: inputId, type: "I", operation: "papurd", variable: `Novo Indicador` });
      mo.mapping += " * 2";
      let loss = this.lossListLocal.find((l) => l.id == this.lossSelected);
      this.areaLossList.push(mi);
      this.areaLossList.push(mo);
      if (lossFounded) {
        lossFounded.AddChildren([mi], mo);
      } else {
        let newLossConfig = new LossConfiguration(loss);

        newLossConfig.AddChildren([mi], mo);

        this.determinatedList.push(newLossConfig);
        this.determinatedList = this.determinatedList.sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? - 1 : 0)
      }
      this.setOthersLast()
    },

    addUndetermineted() {

      let parentId = `${Math.round(((Math.random() * 10000) + (Math.random() * 100000)))}-novoUndeterminated`;

      let mo = new Mapping({ id: parentId, parentId: parentId, type: "O", operation: "papuri" });
      let mi = new Mapping({ id: parentId, parentId: parentId, type: "I", operation: "papuri", variable: `Novo Indicador` });

      mo.mapping += " * 2";
      this.undeterminatedList.push(new LossStructure([mi], mo))

      this.areaLossList.push(mi);

      this.areaLossList.push(mo);

    },


    deleteSingleInput(modelToRemove) {
      if (this.determinatedSelected == "D") {
        this.determinatedList.forEach(l => l.removeInputMapping(modelToRemove))
      } else {
        this.undeterminatedList.forEach(l => l.removeInputMapping(modelToRemove))
      }
      this.delete(modelToRemove)
    },

    async deleteConfig(index) {
      let mapToDelete = this.areaLossList[index];

      if (typeof mapToDelete.id == "string" && mapToDelete.id.includes("novoInput")) {

        this.removeAssociatedItemsFromLossList(mapToDelete.id);

        this.removeLossConfig(mapToDelete.id);

      } else if (typeof mapToDelete.id == 'string' && mapToDelete.id.includes('novoUndeterminated')) {
        this.removeAssociatedItemsFromLossList(mapToDelete.id);
        this.removeLossConfigUnde(mapToDelete.id);

      } else {
        this.determinatedSelected == 'D' ?
          await this.removeDeterminated(mapToDelete) :
          await this.removeUndeterminated(mapToDelete);

        this.removeAssociatedItemsFromLossListParentID(mapToDelete.parentId);


      }
    },

    removeAssociatedItemsFromLossListParentID(parentId) {
      let itemsToRemove = this.areaLossList.filter(item => item.parentId === parentId);

      itemsToRemove.forEach(item => {
        this.removeItemLossList(item.id);
      });
    },


    removeAssociatedItemsFromLossList(id) {
      let itemsToRemove = this.areaLossList.filter(item => item.id === id);


      itemsToRemove.forEach(item => {
        this.removeItemLossList(item.id);
      });
    },




    removeLossConfig(id) {
      let list = this.determinatedSelected == 'D' ? this.determinatedList : this.undeterminatedList;


      list.forEach(lossConfig => {
        lossConfig.childrens.forEach((child) => {
          child.mi = child.mi.filter(mi => mi.id !== id);

          if (child.mo.id === id) {
            child.mo = null; 
          }
        });
      });

      list.forEach((lossConfig, indexLossConfig) => {
        lossConfig.childrens = lossConfig.childrens.filter(child => {
          return child.mi.length > 0 || child.mo !== null;
        });

        if (lossConfig.childrens.length === 0) {
          list.splice(indexLossConfig, 1);
        }
      });

    },

    removeLossConfigUnde(id) {
      let list = this.undeterminatedList;

      list.forEach((lossStructure, indexLossConfig) => {
        if (lossStructure.mi && lossStructure.mi.some(mi => mi.id === id)) {
          lossStructure.mi = lossStructure.mi.filter(mi => mi.id !== id);
        }

        if (lossStructure.mo && lossStructure.mo.id === id) {
          lossStructure.mo = null; 
        }

       
        if ((!lossStructure.mi || lossStructure.mi.length === 0) && !lossStructure.mo) {
      
          list.splice(indexLossConfig, 1);
        }
      });

     
      this.undeterminatedList = list;
    },


    removeItemLossList(id) {
      let index = -9999
      this.areaLossList.forEach((m, i) => {
        if (m.id == id)
          index = i
      })
      this.areaLossList.splice(index, 1)
    },




    async removeDeterminated(mapToDelete) {
      let indexDetLoss = -9999;
      let indexLossChildren = -9999;
      let idMapToDelete = -9999;
      let deleteMap = [];


      this.determinatedList.forEach((d, iDet) => {
        d.childrens.forEach((c, iMap) => {

         
          let miToRemove = c.mi.filter(mi => mapToDelete.parentId === mi.parentId);
          if (miToRemove.length) {
            deleteMap = deleteMap.concat(miToRemove);
            indexDetLoss = iDet;
            indexLossChildren = iMap;
            idMapToDelete = c.mo.id;
          }

        
          if (mapToDelete.parentId === c.mo.parentId) {
            deleteMap.push(c.mo);
            idMapToDelete = c.mi.length ? c.mi[0].id : c.mo.id; 
          }
        });
      });

  

   
      let allDeleted = true;
      for (let i = 0; i < deleteMap.length; i++) {
        const success = await this.delete(deleteMap[i]);
        if (!success) {
          allDeleted = false;
        }
      }

      if (indexDetLoss != -9999 && allDeleted) {
        this.determinatedList[indexDetLoss].childrens.splice(indexLossChildren, 1);


        if (!this.determinatedList[indexDetLoss].childrens.length) {
          this.determinatedList.splice(indexDetLoss, 1);
        }
      }

      return idMapToDelete;
    },

    async removeUndeterminated(mapToDelete) {
      let idMapToDelete = -9999;
      let indexUnDetLoss = -9999;
      let deleteMap = [];

     
      this.undeterminatedList.forEach((u, iUnd) => {

 
        let miToRemove = u.mi.filter(mi => mapToDelete.parentId === mi.parentId);
        if (miToRemove.length) {
          deleteMap = deleteMap.concat(miToRemove);
          indexUnDetLoss = iUnd;
          idMapToDelete = u.mo.id;
        }

 
        if (mapToDelete.parentId === u.mo.parentId) {
          deleteMap.push(u.mo);
          idMapToDelete = u.mi.length ? u.mi[0].id : u.mo.id;
        }
      });

  
      let allDeleted = true;
      for (let i = 0; i < deleteMap.length; i++) {
        const success = await this.delete(deleteMap[i]);
        if (!success) {
          allDeleted = false;
        }
      }


      if (indexUnDetLoss != -9999 && allDeleted) {
        this.undeterminatedList.splice(indexUnDetLoss, 1);
      }

      return idMapToDelete;
    },


    async delete(model) {
      let success = false
      const url = `${urlMainAPI}/deletemapping`;
      await axios
        .post(url, model)
        .then((res) => {
          success = true;
          defaultSuccess(res.data)
        }).catch();

      return success
    },
  },

  mounted() {
    this.loadDetermineted();
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.config-user {
  display: grid;
  grid-template-columns: 480px calc(100% - 480px);
}

.side-loss-view {
  overflow-x: auto;
}

.loss-view {
  min-width: 540px;
}

.update-config-user {
  padding: 35px 4px -1px 4px;
  margin-right: 30px;
}

.adicao {
  margin-bottom: 19px;
}

.btn-iconAdd {
  font-size: 25px;
  cursor: pointer;
  margin-left: calc(50% - 12.5px);
  margin-top: 8px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}
</style>
